import {
  useMutation,
  UseMutationOptions,
  useQuery,
  UseQueryOptions
} from "@tanstack/react-query";
import $api from "../../api/$api";
import {
  TCreateCustomFindingPayload,
  TUpdateCustomFindingPayload,
  TDeleteCustomFindingPayload,
  TQueries,
  TDataToken
} from "./type";

export const getCustomFindingTypes = (data: TDataToken, queries: TQueries) => {
  return $api
    .get(`/custom-finding-types`, {
      token: data.accessToken,
      params: { ...queries }
    })
    .then((response) => response);
};

export const useGetCustomFindingTypes = (
  data: TDataToken,
  queries: TQueries,
  config?: {}
) => {
  return useQuery({
    queryKey: ["custom-finding-types", queries],
    staleTime: 1000 * 60 * 1,
    queryFn: () => getCustomFindingTypes(data, queries) as any,
    refetchOnWindowFocus: false,
    ...(config as UseQueryOptions<any>)
  });
};

export const createNewCustomFinding = (
  data: TDataToken,
  payload: TCreateCustomFindingPayload
) => {
  return $api
    .post(
      `/categories`,
      {},
      { params: { ...payload }, token: data.accessToken }
    )
    .then((response) => {
      return response;
    });
};

export const useCreateCustomFinding = (
  data: TDataToken,
  config?: UseMutationOptions<any, unknown, TCreateCustomFindingPayload>
) => {
  return useMutation({
    mutationFn: (payload: TCreateCustomFindingPayload) =>
      createNewCustomFinding(data, payload),
    ...config
  });
};

export const updateCustomFinding = (
  data: TDataToken,
  payload: TUpdateCustomFindingPayload
) => {
  return $api
    .put(`/categories`, {}, { params: { ...payload }, token: data.accessToken })
    .then((response) => {
      return response;
    });
};

export const useUpdateCustomFinding = (
  data: TDataToken,
  config?: UseMutationOptions<any, unknown, TUpdateCustomFindingPayload>
) => {
  return useMutation({
    mutationFn: (payload: TUpdateCustomFindingPayload) =>
      updateCustomFinding(data, payload),
    ...config
  });
};

export const deleteCustomFinding = (
  data: TDataToken,
  payload: TDeleteCustomFindingPayload
) => {
  return $api
    .delete(`/categories`, { params: { ...payload }, token: data.accessToken })
    .then((response) => {
      return response;
    });
};

export const useDeleteCustomFinding = (
  data: TDataToken,
  config?: UseMutationOptions<any, unknown, TDeleteCustomFindingPayload>
) => {
  return useMutation({
    mutationFn: (payload: TDeleteCustomFindingPayload) =>
      deleteCustomFinding(data, payload),
    ...config
  });
};
